import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';

dayjs.extend(localizedFormat);

import LazyLoad from 'react-lazyload';

import AspectRatio from '@/components/common/AspectRatio';
import NarrowWidth from '@/components/common/layout/NarrowWidth';

const ContentBlock = ({ value }) => {
  const sections = value;
  return (
    <NarrowWidth>
      <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 md:mb-12">
        {sections.map(({ title, date, url, image, description }) => {
          return (
            <div className="" key={url}>
              <AspectRatio
                ratio={'3:2'}
                hasImageHover={true}
                className="block mt-2 mb-2 bg-gray-200 shadow hover:shadow-lg">
                <LazyLoad offset={150} once>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <img src={image.url} alt={title} />
                  </a>
                </LazyLoad>
              </AspectRatio>
              <h3 className="mt-4 text-xl">
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {title}{' '}
                  <span className="text-base font-light text-gray-900">
                    | {dateFormatter(date)}
                  </span>
                </a>
              </h3>
              <p
                className="my-2 text-gray-500 text-md"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          );
        })}
      </div>
    </NarrowWidth>
  );
};

const dateFormatter = date => {
  return dayjs(date).format('ll');
};

export default ContentBlock;
